import { Stack } from 'src/components/mui';
//@ts-ignore
import React from 'react';

type Props = {
  first: string;
  second: string;
  direction?: 'row' | 'column';
};

export default function KeyAsset({ first, second, direction = 'row' }: Props) {
  return (
    <Stack direction={direction} spacing={1} justifyContent="center">
      <i style={{ fontSize: '50px' }} className={`fa-light ${first}`} />
      <i style={{ fontSize: '50px' }} className={`fa-light ${second}`} />
    </Stack>
  );
}
